<template>
  <div id="content" class="scouting_space">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="closeConfirmDialog()" @confirmed="validateScoutingBrief($event)" message="Are you sure? Once approved, the brief will be made available to the customer." ></ConfirmModal>

    <div class="container">

      <AddCommentModal :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>


          <div class="scouting_space_stepper">
            <button :class="[
              'step',
              (step == 1) ? 'active' : '',
            ]" @click="save(false);step = 1;">
              <span class="stepNumber ">1</span> <span class="stepName">Validate your scouting brief</span>
            </button>
            <button :class="[
              'step',
              (step == 2) ? 'active' : '',
            ]" @click="save(false);step = 2">
              <span class="stepNumber">2</span> <span class="stepName">Validate your candidates selection requirements</span>
            </button>
          </div>



    <div class=" scouting_space_1" v-if="step == 1">
      <div id="element-to-convert">


      <div class="row">
        <div class="col-12 text-center">
           <span class="search_field_name">{{search_field.name}}</span>
        </div>

      </div>
      <div class="row scouting_space_content" v-if="search_field.scouting_challenge">
        <!-- problem_to_be_solved -->
          <div class="col-12 col-lg-6 col">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_problem_to_be_solved.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">PROBLEM TO BE SOLVED <span class="scouting_brief_item_subtitle"> (from your business challenge)</span></span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.problem_to_be_solved.value" class="addValueInput"  rows="4"  :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit"  ></textarea>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.problem_to_be_solved.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.problem_to_be_solved.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.problem_to_be_solved.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong>{{comment.value}} </span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("problem_to_be_solved")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>
          <!-- recommanded_application_area -->
          <div class="col-12 col-lg-6 col">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_recommended_application_area.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">POTENTIAL INDUSTRIES</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.recommanded_application_area.value" class="addValueInput"  rows="4" :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit"  ></textarea>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.recommanded_application_area.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.recommanded_application_area.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.recommanded_application_area.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong>{{comment.value}} </span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("recommanded_application_area")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>

          <!-- partnership_objectives -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_partnership_objective.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">PARTNERSHIP OBJECTIVE <span class="scouting_brief_item_subtitle">(from your business challenge)</span></span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.partnership_objectives.value" class="addValueInput"  rows="4"   :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit"  ></textarea>

                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.partnership_objectives.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.partnership_objectives.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.partnership_objectives.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong>{{comment.value}} </span>
                        <span v-else>{{comment}}</span>
                      </div>

                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("partnership_objectives")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>


          <!-- anticipated_impact -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_anticipated_impact.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">ANTICIPATED IMPACT ON BUSINESS OR OPERATING MODEL</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.anticipated_impact.value" class="addValueInput"  rows="4"  :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit"  ></textarea>
                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.anticipated_impact.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.anticipated_impact.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.anticipated_impact.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong>{{comment.value}} </span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right">
                      <button type="button" class="add_new_comment" @click='openModal("anticipated_impact")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>


          <!-- recommanded_topics -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_recommended_topics.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">RECOMMENDED TOPICS / TECHNOLOGIES</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.recommanded_topics.value" class="addValueInput"  rows="4"  :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit" ></textarea>

                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.recommanded_topics.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.recommanded_topics.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.recommanded_topics.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong>{{comment.value}} </span>
                        <span v-else>{{comment}}</span>
                      </div>

                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("recommanded_topics")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>


          <!-- key_engagment_steps -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item">
                <img :src="require('@/assets/search_field_1_key_engagement_steps.svg')" class="scouting_brief_item_img"/>
                <span class="scouting_brief_item_title">OTHER CONSIDERATIONS OR POTENTIAL HURDLES</span>
                <div class="scouting_brief_item_content">
                  <textarea v-model="search_field.scouting_challenge.scouting_brief.key_engagment_steps.value" class="addValueInput"  rows="4"  :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit" ></textarea>

                </div>
                <div class="scouting_brief_item_comments">
                  <div  v-if=" search_field.scouting_challenge.scouting_brief.key_engagment_steps.comments.length > 0">


                  <small>Comment<span v-if=" search_field.scouting_challenge.scouting_brief.key_engagment_steps.comments.length > 1">s</span></small>
                  <div class="comments_list">
                      <div class="one_comment" v-for="(comment, i) in search_field.scouting_challenge.scouting_brief.key_engagment_steps.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong>{{comment.value}} </span>
                        <span v-else>{{comment}}</span>
                      </div>


                  </div>
                      </div>
                  <div class="add_comment col-12 text-right" >
                      <button type="button" class="add_new_comment" @click='openModal("key_engagment_steps")' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
          </div>

          <!-- <div class="col-12 col-lg-6 mt50">
              <div class=" text-center">
                <span style="display:block;color:#3783C5;text-transform:uppercase;font-size:18px;line-height:21px;margin-top:20px;">Keep your name confidential for potential candidates?</span>
                <label class="rocker mt20 ">
            <input type="checkbox" v-model="search_field.scouting_challenge.scouting_brief.keep_name_confidential"  :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit" >
            <span class="switch-left">YES</span>
            <span class="switch-right">NO</span>
          </label>


              </div>
          </div> -->
          <div class="col-12 col-lg-6 col mt50">
              <div class="scouting_brief_item text-center" style="padding:50px;">
                          <span class="scouting_brief_item_title">ADDITIONAL INSIGHTS</span>
                        <button class="addMoreInfoBtn" @click="addMoreInfo = true" v-if="addMoreInfo == false && !search_field.scouting_challenge.scouting_brief.extra_info"  :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit" >
                      <img :src="require('@/assets/search_field_1_add_more_information.svg')" alt="" style="width:60px">
                      <span style="display:block;color:#3783C5;text-transform:uppercase;font-size:12px;line-height:15px;margin-top:20px;">Add more information</span>

                </button>


                <textarea v-model="search_field.scouting_challenge.scouting_brief.extra_info" class="addValueInput" rows="4" v-if="addMoreInfo == true || search_field.scouting_challenge.scouting_brief.extra_info" :disabled="search_field.scouting_challenge.scouting_brief.isExpertSubmit" ></textarea>


              </div>
          </div>




      </div>
      </div>
      <!-- <div class="step_footer">
        <button type="button" name="button" class="next_step_btn" @click='step++'>
          Next step
          <img :src="require('@/assets/next.svg')" alt="">
        </button>
      </div> -->

      <div class="step_footer">
        <div class="row row_center">
        <div class="col-6 text-left" v-if="search_field.project">
          <router-link v-if="search_field.project" type="button" name="button" class="prev_step_btn" :to='"/expert/project/"+search_field.project.$oid'>
            <img :src="require('@/assets/prev.svg')" alt="">
            BACK TO DASHBOARD

          </router-link>
        </div>
        <div class="col-6 text-right" v-if="search_field.scouting_challenge">

          <button type="button" name="button" class="next_step_btn" @click='step++'>
            Next step
            <img :src="require('@/assets/next.svg')" alt="">
          </button>
        </div>

        </div>

      </div>
    </div>



    <div class=" scouting_space_2" v-if="step == 2">
      <ExplanationLink text="EXPLANATIONS NEEDED?" link="/"/>

      <div class="row">
        <div class="col-12 text-center">
           <span class="search_field_name">{{search_field.name}}</span>
        </div>
      </div>
      <div class="scouting_space_content">


      <div class="row ligne_form">
        <div class="col-12 col">
            <div class="zone_input">
                <div class="zone_input_header">
                  <img :src="require('@/assets/search_field_2_solution_developement_stage.svg')" class="zone_input_icon" alt="">
                  <span class="zone_input_name">SOLUTION DEVELOPMENT STAGE</span>
                </div>
                <div class="triangle_container">
                  <div class="text-center triangle_right" style="">
                    PRE-COMMERCIAL DEVELOPMENT AND VALIDATION
                  </div>
                  <div class="text-center triangle_left" >
                    COMMERCIAL MARKET
                  </div>
                </div>
                <div class="myCheck">
  <label class="mdl-checkbox mdl-js-checkbox  mdl-js-ripple-effect"  v-for="(fs,i) in solution_developement_stages" :key="i">
      <input type="checkbox" :value="fs.value" v-model="search_field.scouting_challenge.candidate_selection_requirements.development_stage" class="mdl-checkbox__input"   :disabled="search_field.scouting_challenge.isSubmit" />
      <span class="mdl-checkbox__label">{{fs.name}}</span>
  </label>

</div>
            </div>
        </div>
      </div>

      <div class="row ligne_form">
        <div class="col-12 col">
            <div class="zone_input">
                <div class="zone_input_header">
                  <img :src="require('@/assets/search_field_2_funding_stage.svg')" class="zone_input_icon" alt="">
                  <span class="zone_input_name">FUNDING STAGE</span>
        </div>
                  <div class="myCheck ml0-xs">
    <label class="mdl-checkbox mdl-js-checkbox  mdl-js-ripple-effect"  v-for="(fs,i) in funding_stage_possibles" :key="i">
        <input type="checkbox" :value="fs.value" v-model="search_field.scouting_challenge.candidate_selection_requirements.funding_stage" class="mdl-checkbox__input"  :disabled="search_field.scouting_challenge.isSubmit" />
        <span class="mdl-checkbox__label">{{fs.name}}</span>
    </label>

</div>

            </div>
        </div>
    <div class="col-12 col-xl-8 col">
            <div class="zone_input">
                <div class="zone_input_header">
                  <img :src="require('@/assets/search_field_2_partners_location.svg')" class="zone_input_icon" alt="">
                  <span class="zone_input_name">PARTNER'S LOCATION</span>
                </div>
                <div class="vselect_container ml65 mt20 ml0-xs" >
                  <treeselect v-model="search_field.scouting_challenge.candidate_selection_requirements.location" :multiple="true" :options="execution_geography_possibles"     :disabled="search_field.scouting_challenge.isSubmit"/>
                </div>
            </div>
        </div>
      </div>

      <div class="row ligne_form">
        <div class="col-12 col-xl-8 col">
            <div class="zone_input">
              <div class="zone_input_header">
                <img :src="require('@/assets/search_field_2_what_type_of_assets.svg')" class="zone_input_icon" alt="">
                <span class="zone_input_name">WHAT TYPE OF ASSETS / CAPABILITIES A POTENTIAL PARTNER MUST HAVE?</span>
              </div>

              <div class="vselect_container ml65 mt20 ml0-xs" >
                <v-autocomplete v-model="search_field.scouting_challenge.candidate_selection_requirements.capabilities_assets" closable-chips  :items="capabilities_assets_possibles" :disabled="search_field.scouting_challenge.isSubmit" item-color="#FFF" item-title="name" item-value="value"  chips multiple></v-autocomplete>
                <div class="add_custom_key_factor" v-if="search_field.scouting_challenge.isSubmit != true">
                  <span>You don’t find what you are looking for ?</span>
                  <button type="button" name="button" @click='dialogAssets = true' :disabled="search_field.scouting_challenge.isSubmit">+ ADD</button>
                  <NewValueModal :dialogVisible='dialogAssets' @close="dialogAssets=false" @newValueIsProposed="setNewValueCAS($event)" formName="Add your assets / capabilities" ></NewValueModal>
                </div>
              </div>


            </div>
        </div>
      </div>

      <div class="row ligne_form">
        <div class="col-12 col-xl-8 col">
          <div class="row ">
            <div class="col-12 mt20">
              <span class="zone_input_name">POTENTIAL PARTNERS ALREADY IDENTIFIED?</span>
            <label class="rocker mt20 ml20">
        <input type="checkbox" v-model="search_field.scouting_challenge.candidate_selection_requirements.already_identified"  :disabled="search_field.scouting_challenge.isSubmit" >
        <span class="switch-left">YES</span>
        <span class="switch-right">NO</span>
      </label>
    </div>
          </div>
        </div>
      </div>


      <div class="row ligne_form">
        <div class="col-12 col">
          <textarea v-model="search_field.scouting_challenge.candidate_selection_requirements.comments" class="comments" placeholder="Comments"  :disabled="search_field.scouting_challenge.isSubmit" ></textarea>

        </div>
      </div>
      </div>
      <div class="step_footer">
        <div class="row row_center">
          <div class="col-12 col-xl-6 text-left">
            <button type="button" name="button" class="prev_step_btn" @click='step = step - 1'>
              <img :src="require('@/assets/prev.svg')" alt="">
              Previous step
            </button>
          </div>
        </div>
      </div>

    </div>



  </div>


</div>
</template>
<script>
 import AddCommentModal from '@/components/modals/addComment.vue'
// import BookACall from '@/components/bookacall.vue'
 import { toast } from 'vue-sonner'
import api from '@/tools/api';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import countries from '@/assets/db_coutries.json';
import Treeselect from 'vue3-treeselect'
// // import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css'

export default {
  components: {
     AddCommentModal,
    Treeselect,

     ConfirmModal,
    // BookACall
  },
  data() {
    return {
      dialog : false,
      dialogAssets: false,
      addMoreInfo : false,
      showConfirmDialog: false,
      add_other_location: "",
      currentSearchFieldForComment : "",
            execution_geography_possibles: countries,
      step: 1,
      pageInfo: {
        mainTitle : "Scouting space",
        subTitle : "Find the most relevant partners",
      },
      search_field : {
        name : 'Search field 1',
        confidential : true,
        more_info: "",
        problem_to_be_solved: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: ['tests'],
        },
        recommanded_application_area: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        partnership_objectives: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        anticipated_impact: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        recommanded_topics: {
          value:"Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: [],
        },
        key_engagment_steps: {
          value : "Post haec Gallus Hierapolim profecturus ut expeditioni specie tenus adesset, Antiochensi plebi suppliciter obsecranti ut inediae dispelleret metum, quae per multas difficilisque causas adfore iam sperabatur, non ut mos est principibus, quorum diffusa potestas localibus subinde medetur aerumnis, disponi quicquam statuit vel ex provinciis alimenta transferri conterminis, sed consularem Syriae Theophilum prope adstantem ultima metuenti multitudini dedit id adsidue replicando quod invito rectore nullus egere poterit victu.",
          comments: []
        },
        isSubmit : false,
      },
      candidate_selection_requirements:{
        location: [],
        funding_stage: ["seed"],
        development_stage: [],
        capabilities_assets: [],
        already_identified: false,
        comments: []
      },

      location_possibles: [
        {
          name: "EU",
          value: "eu"
        },
        {
          name: "US",
          value: "us"
        },
        {
          name: "Asia",
          value: "asia"
        },
        {
          name: "All",
          value: "all"
        },
      ],
      capabilities_assets_possibles: [],
      funding_stage_possibles: [
        {
          name: "Don't know / Not relevant",
          value: "not_relevant"
        },
        {
          name: "Pre-seed",
          value: "preseed"
        },
        {
          name: "Seed",
          value: "seed"
        },
        {
          name: "Series A",
          value: "seriesA"
        },
        {
          name: "Series B",
          value: "seriesB"
        },
        {
          name: "Series C",
          value: "seriesC"
        },
        {
          name: "IPO",
          value: "IPO"
        },

      ],
      solution_developement_stages: [
        {
          name: "Research",
          value: "research"
        },
        {
          name: "Prototype",
          value: "prototype"
        },
        {
          name: "MVP",
          value: "mvp"
        },
        {
          name: "Testing",
          value: "testing"
        },
        {
          name: "Commercial Launch",
          value: "launch"
        },
        {
          name: "Scaleup",
          value: "scaleup"
        },
        {
          name: "At scale",
          value: "atscale"
        },
      ]
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
    openModal(search_field){
      this.currentSearchFieldForComment = search_field;
      this.dialog = true;
    },
    closeModal(){
      this.currentSearchFieldForComment = "";
      this.dialog = false;
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
    },
    save(notify){
      console.log(this.search_field.scouting_challenge);
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/admin_save/"+this.$route.params.search_field_id,this.search_field.scouting_challenge,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
        if(notify)toast.success("Your scouting brief has been saved!");

    }).catch( (e) => {
      console.log(e);
        if(notify)toast.error("Sorry an error occurs !")
    });

  },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/add_comment/"+this.$route.params.search_field_id,
        {
          comment : v,
          topic : this.currentSearchFieldForComment
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        toast.success("Your comment is added");
        this.search_field.scouting_challenge.scouting_brief[this.currentSearchFieldForComment].comments.push(r.data);
          this.currentSearchFieldForComment = "";
      }).catch( () => {
          this.currentSearchFieldForComment = "";
          toast.error("Sorry an error occurs !")
      });

        // this.key_execution_factors_possibles.push({name:v,value:v,customer:true});
        // this.projet.key_execution_factors.push(v);
      }

      this.dialog = false;
    },
    addCustomLocation(){
      if(this.add_other_location != ''){
        this.location_possibles.push({name:this.add_other_location,value:this.add_other_location, custom: true});
        this.search_field.scouting_challenge.candidate_selection_requirements.location.push(this.add_other_location);
        this.add_other_location = '';

      }
    },
    setNewValueCAS(v){
      if(v){
        this.capabilities_assets_possibles.push({name:v,value:v.replace(/ /g,"_"),custom:true});
        this.search_field.scouting_challenge.candidate_selection_requirements.capabilities_assets.push(v);
      }
      this.dialogAssets = false;
    },
    generateReport () {
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/admin_save/"+this.$route.params.search_field_id,this.search_field.scouting_challenge,
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        this.$refs.html2Pdf.generatePdf()

      }).catch( (e) => {
        console.log(e);
        toast.error("Sorry an error occurs !")
      });

    },
    validateScoutingBrief(){
        this.showConfirmDialog =false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/scouting_challenge/expert_submit/"+this.$route.params.search_field_id,this.search_field.scouting_challenge,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
      toast.success("Scouting brief has been successfully submitted");
      this.search_field.scouting_challenge.scouting_brief.isExpertSubmit = true;
    }).catch( (e) => {
      console.log(e);
        toast.error("Sorry an error occurs !")
    });

    },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

   api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_key_exection_factors_startups").then( (r) => {
     this.capabilities_assets_possibles = r.data
   }).catch( (e) => {
   if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
   else toast.error("Sorry an error occurs !")
   });
   api.get(process.env.VUE_APP_API_URL+"/search_field/scouting_challenge/"+this.$route.params.search_field_id).then( (r) => {
     console.log(r.data);
     this.search_field = r.data;

   }).catch( (e) => {
     console.log(e);
      toast.error("Sorry an error occurs !")
  });


},
watch: {
  step(v) {
    console.log(v);
      window.scrollTo(0, 0)
  }
}
}
</script>
<style >
.search_field_name{
  font-size: 30px;
  line-height: 36px;
  color: #3783C5;
  text-transform: uppercase;
}


.scouting_space_stepper{
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 50px;

}
.scouting_space_stepper .step{
  border-bottom: 1px solid #ADB3B5;
  position : relative;
  flex: 1;
  text-align: center;
  padding: 10px;
  text-decoration: none;
}
.scouting_space_stepper .step.active{
    border-bottom: 2px solid #3783C5;
}
.scouting_space_stepper .active:after{
  content: '';
position: absolute;
left: calc(50% - 15px);
top: 100%;
width: 0;
height: 0;
border-left: 15px solid transparent;
border-right: 15px solid transparent;
border-top: 15px solid #3783C5;
clear: both;
}
.scouting_space_stepper .stepNumber{
  font-size: 36px;
  line-height: 44px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.scouting_space_stepper .stepName{
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ADB3B5;
}
.scouting_space_stepper .active .stepNumber,
.scouting_space_stepper .active .stepName
{
  color: #3783C5;
}


.step_footer{
  /* display:flex;
  margin-top: 50px;
  align-items: center; */
  margin-top: 50px;
}
.step_footer .notice{
  flex: 1;
  font-size:14px;
  line-height: 22px;
  font-weight: 300;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
  text-decoration: none;
}
.next_step_btn img{
  margin-left:10px;
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
}
.prev_step_btn img{
  margin-right:10px;
}
.scouting_space_1,
.scouting_space_2,
.scouting_space_3{
  padding: 50px;
  background: #FFF;
}

.space_title_zone{
  margin-bottom: 50px;
}
.space_title{
  text-align: left;
  font-size: 21px;
  line-height: 25px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
opacity: 1;
display: block;
}
.zone_input{
}
.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
height: 40px;
padding: 5px;
}
textarea.addValueInput{
  border: 1px solid #DDDDDD;
border-radius: 2px;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 background:#FFF;
 border: 1px solid #DDDDDD;
 width:100%;
}

.ml65{
  margin-left:65px;
}
textarea.comments{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
 resize: none;
 height:100px;
 padding: 10px;
}

.ligne_form{
  margin-top: 50px;
}

/*
.scouting_space_2 .row{
  margin-top:25px;
  margin-bottom: 25px;
}

.zone_input_subname{
  text-align: left;
  font-size:16px;
  line-height: 22px;
letter-spacing: 0px;
color: #3783C5;
margin-left: 65px;
}
.zone_input_checkboxes{
  margin-left: 65px;
  width: calc(100% - 65px);
  display: flex;
  margin-top:20px;
  gap: 20px;
  flex-wrap: wrap;
}

.partnership_objectivess_label{
  padding:12px 30px;
  background: #EFEFEF 0% 0% no-repeat padding-box;
border-radius: 3px;
min-width: calc(20% - 20px);
max-width: calc(20% - 20px);
flex-basis: 0;
flex: 1;
display:flex;
flex-direction: column;
gap: 10px;
border: 1px solid #EFEFEF;
}
input[type='checkbox']{
  width: 24px;
height: 24px;
margin-top:auto;
}
.checkbox_container{
  width:100%;
  display:block;
  text-align: right;
  align-self: end;
margin-top: auto;
}
.partnership_objectivess_label.add_other_objectif{
background:#FFF;
}
.add_other_objectif input{
  border:1px solid #EFEFEF;
  padding: 5px;
}
.checkbox_container button{
  font-size: 18px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
}


.vselect_container{
  margin-top: 20px;
}
.vselect_container .v-field{
  background: #FFF !important;
  border: 1px solid #CCC;
}
.vselect_container .v-field__field,
.vselect_container .v-field__append-inner{
    background: #FFF !important;
}
.v-field--variant-filled .v-field__overlay {
  opacity: 0 !important;
}
.vselect_container .v-field__append-inner i {
  color: #3783C5;
}
.add_custom_key_factor{
  display: flex;
  justify-content: center;
}
.add_custom_key_factor_without_text{
  display: flex;
  justify-content: flex-end;
}
.add_custom_key_factor span{
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
  flex-grow: 1;
}
.add_custom_key_factor button,
.add_custom_key_factor_without_text button{
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #3783C5;
text-transform: uppercase;
}
.ligne_inner_form{
  margin-top:40px;
}
.inputs_container{
  margin-left: 65px;
}

.ligne_inner_form .vselect_container{
  margin-left:65px;
}
.v-autocomplete .v-field .v-field__input{
  padding: 7px;
min-height: 40px;

}
.search_field_input input{
  margin-top: 10px;
  margin-bottom: 10px;
} */


.scouting_brief_item{
  width: 100%;
border: 1px solid #DDD;
border-radius: 10px;
position: relative;
}
.scouting_brief_item_img{
  width: 55px;
position: absolute;
top: -25px;
left: -25px;
}
.scouting_brief_item_title{
  position: absolute;
top: 0;
left: 50px;
background: #FFF;
transform: translateY(-50%);
padding-left: 10px;
padding-right: 10px;
padding-top: 6px;
padding-bottom: 6px;
font-size: 16px;
line-height: 15px;
color: #3783C5;
}
.scouting_brief_item_subtitle{
  color: #000;
  font-size: 12px;
}
.scouting_brief_item_content{
  padding: 50px;
}
.scouting_brief_item_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
}
.scouting_brief_item_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.scouting_brief_item_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.scouting_brief_item_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}

.scouting_space_content{
  margin-top: 50px;
}
.scouting_space_content .col{
  padding-left:20px;
  padding-right: 20px;
  margin-top:20px;
  margin-bottom: 20px;
}
.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}
.locationSelector{
  margin-top: 20px;
  padding-left: 65px;
}
.location_selection{
  font-size: 16px;
  line-height: 21px;
  color:#000;
  margin-top:20px;
  margin-bottom: 20px;
  display:block;
}
.location_selection input{
  width: 20px;
height: 20px;
}

.add_other_inline input{
  border: 1px solid #DDD;
padding: 5px;
border-right: none;
}
.add_other_inline button{
  border: 1px solid #DDD;
  padding: 5px;
  color: #3783C5;
  border-left: none;
  font-size:18px;
  line-height:22px;
  font-weight: 600;
}

.add_custom_key_factor{
  display: flex;
  justify-content: center;
}
.add_custom_key_factor_without_text{
  display: flex;
  justify-content: flex-end;
}
.add_custom_key_factor span{
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
  flex-grow: 1;
}
.add_custom_key_factor button,
.add_custom_key_factor_without_text button{
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #3783C5;
text-transform: uppercase;
}

.mt20{
  margin-top: 20px;
}

.myCheck{
  width:100%;
  display:flex;
  padding-left:50px;
  padding-right: 50px;
  margin-top:50px;
}
.mdl-checkbox {
flex: 1;
  text-align: center;
  padding: 10px;
  position: relative;
}

.mdl-checkbox:after,
.mdl-checkbox:before {
  height: 2px;
  background: linear-gradient(to right, transparent 50%, #DDD 50%);
  background-size: 10px 2px;
  content: "";
  top: 20px;
  position: absolute;
  right:0;
  left:0;
}

.mdl-checkbox:before {
  right: calc(50% + 12px);
}

.mdl-checkbox:after {
  left: calc(50% + 12px);
}


.mdl-checkbox:last-of-type:before {
  height: 2px;
  background: linear-gradient(to right, transparent 50%, #DDD 50%);
  background-size: 10px 2px;
  content: "";
  top: 20px;
  position: absolute;
  right:0;
  left:0;
}
.mdl-checkbox:last-of-type:after {
  background: transparent;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 24px dashed #DDD;
  float: right;
  left: calc(100% - 12px);
  height: 24px;
  width: 24px;
  top: 7px;

}
input.mdl-checkbox__input {
  width:24px;
  height:24px;
  border-width:1px;
  display: block;
  margin: auto;
  position: relative;
  z-index:50;
}

.mdl-checkbox__label{
  margin-top:10px;
  margin-bottom:20px;
  font-size:14px;
  z-index:50;
  background:#FFF;
  position:relative;
}

@media screen and (max-width: 990px){
  .myCheck{
    width:100%;
    display:flex;
    padding-left:50px;
    padding-right: 50px;
    margin-top:50px;
    flex-direction: column-reverse;
    gap: 20px;
  }
  .mdl-checkbox::after, .mdl-checkbox::before {

    width: 2px;
    background: linear-gradient(to bottom, transparent 50%, #DDD 50%);
      background-size: auto;
    background-size: auto;
    background-size: 2px 10px;
    content: "";
    top: 0;
    position: absolute;
    right: 0;
    left: 50%;
    height: calc(100% + 20px);
  }

  .mdl-checkbox:last-of-type:before {

      width: 2px;
      background: linear-gradient(to bottom, transparent 50%, #DDD 50%);
        background-size: auto;
      background-size: auto;
      background-size: 2px 10px;
      content: "";
      top: -20px;
      position: absolute;
      right: 0;
      left: 50%;
      height: calc(100% + 60px);

  }
  .mdl-checkbox:last-of-type:after {
    background: transparent;
    border-right: 14px solid transparent;
    border-left: 14px solid transparent;
    border-bottom: 24px dashed #DDD;
    float: right;
    height: 24px;
    width: 24px;
    top: -50px;
    left: calc(50% - 14px);
  }
}


.next_step_btn img,
.prev_step_btn img{
  width:20px;
}

.row_center{
  align-items: center;
}

.mt50{
  margin-top: 50px !important;
}
.triangle_container{
  display:flex;
  margin-top:20px;
}
.triangle_left{
  width:45%;padding:10px;display:inline-block;
  position:relative;
  background: #3783C5 0% 0% no-repeat padding-box;
color:#FFF;
border-top-right-radius: 8px;
border-bottom-right-radius: 8px;
opacity: 0.85;
}
.triangle_right{
  position:relative;
  background: #3783C5 0% 0% no-repeat padding-box;
color:#FFF;
border-top-left-radius: 8px;
border-bottom-left-radius: 8px;
width:55%;padding:10px;display:inline-block;
}
.triangle_right:after{
  content: '';
  position: absolute;
  display: block;
  right: -25px;
  top: 0;
  bottom: 0;
  width: 25px;
  height: 100%;
  background: #3783C5;
  -webkit-clip-path: polygon(0 0, 0% 100%, 100% 50%);
  clip-path:polygon(0 0, 0% 100%, 100% 50%);

}
@media screen and (max-width: 990px){
  .triangle_container{
    display:none;
  }

}
.scouting_space_2{
  position:relative;
}
.explanation_needed{
  position:absolute;
  right: 20px;
  top: 20px;;
}

.downloadBtnWhite{
  border: 1px solid #3783C5;
border-radius: 50px;
color:#3783C5;
text-transform: uppercase;
  padding: 10px 10px 10px 10px;
  font-size:12px;
  line-height:15px;
}

.ml20{
  margin-left:20px;
}

@media screen and (max-width:690px){
  .ml0-xs{
    margin-left: 0 !important;
    padding-left: 0 !important;
  }
  .scouting_brief_item_content {
  padding: 25px;
}
.scouting_space_1,
.scouting_space_2,
.scouting_space_3{
padding-left:15px !important;
padding-right:15px !important;
}

}



.vue-treeselect__control {
  background: #EDEDED !important;
  height: 60px;
}

.vue-treeselect__control-arrow-container {
  display: table-cell !important;
}

</style>
